module.exports = __webpack_public_path__ + "static/services_hotel-eddc7b28590d466823f9e59cd28e4791.jpg";